const MASKED_SEARCH_PARAM_KEYS = ['token'];
const MASK = '[masked]';

/**
 * 招待メールのリンクの確認トークンなど、ログ・分析・セッション記録に残してはいけないクエリパラメータの値をマスクする。
 */
export const maskSensitiveSearch = (search: string): string => {
  const params = new URLSearchParams(search);
  MASKED_SEARCH_PARAM_KEYS.forEach((key) => {
    if (params.has(key)) {
      params.set(key, MASK);
    }
  });
  const masked = params.toString();
  return masked ? `?${masked}` : '';
};

export const maskSensitiveHref = (href: string): string => {
  const url = new URL(href);
  url.search = maskSensitiveSearch(url.search);
  return url.toString();
};
